import React, { useEffect, useState, useCallback } from "react";
import { Link, useHistory, useParams } from "react-router-dom";

import Layout from "../../../../../components/Layout";
import Container from "../../../../../components/Container";
import Flex from "../../../../../components/Flex";
import Content from "../../../../../components/Content";
import Button from "../../../../../components/Button";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import { useAuthState } from "../../../../../components/AuthProvider";

import styles from "./ViewUserAccess.module.scss";

const ViewUserAccess = () => {
  const moment = require("moment-timezone");
  const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
  const userRolesApiUrl = `${clientConfigApiDomain}/rpc/user_roles`;
  const { id } = useParams();
  const { accessId } = useParams();

  const history = useHistory();
  const { user } = useAuthState();

  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [userAccessData, setUserAccessData] = useState([]);

  const fetchUserAccess = useCallback(async () => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    const response = await fetch(`${userRolesApiUrl}/?id=${accessId}`);
    const data = await response.json();
    setUserAccessData(data.results[0]);
    setIsLoading(false);
    setHasLoaded(true);
  }, [
    accessId,
    setHasLoaded,
    setIsLoading,
    setUserAccessData,
    userRolesApiUrl
  ]);

  useEffect(() => {
    if (!hasLoaded) {
      fetchUserAccess();
    }
  }, [fetchUserAccess, hasLoaded]);

  let loadedBreadcrumbs = "";
  if (isLoading) {
    loadedBreadcrumbs = "Loading ...";
  } else if (hasLoaded) {
    loadedBreadcrumbs = (
      <Breadcrumbs>
        <Breadcrumbs.Item render={() => <Link to="/">Home</Link>} />
        <Breadcrumbs.Item
          render={() => <Link to="/admin">Administration</Link>}
        />
        <Breadcrumbs.Item render={() => <Link to="/admin/users">Users</Link>} />
        <Breadcrumbs.Item
          render={() => (
            <Link to={`/admin/users/${id}`}>
              User:{" "}
              {userAccessData.user
                ? userAccessData.user.last_name +
                  ", " +
                  userAccessData.user.first_name
                : ""}
            </Link>
          )}
        />
        <Breadcrumbs.Item
          last
          render={() =>
            `Access Details: ` +
            (userAccessData.role
              ? userAccessData.role.name +
                " role for " +
                userAccessData.client.name
              : "")
          }
        />
      </Breadcrumbs>
    );
  }

  const isVisible = selectedUser => {
    return (
      user.role === "Global Admin" || selectedUser.role.name !== "Global Admin"
    );
  };

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          <Flex.Item span={12}>{loadedBreadcrumbs}</Flex.Item>
          {isLoading ? (
            <span>Loading..</span>
          ) : hasLoaded ? (
            <Flex.Item span={12}>
              <Content>
                <h1>
                  Access Details:{" "}
                  {userAccessData.role
                    ? userAccessData.role.name +
                      " role for " +
                      userAccessData.client.name
                    : ""}
                </h1>
              </Content>
              <div className={styles.base}>
                <div className={styles.detailsFlex}>
                  <h3>Access Details</h3>
                  <div>
                    {/* User cant edit or delete his own access */}
                    {user.id !== userAccessData.user.id &&
                    isVisible(userAccessData) ? (
                      <Button
                        className={styles.margin}
                        primary
                        onClick={() => {
                          history.push(`${accessId}/edit`);
                        }}
                      >
                        Edit
                      </Button>
                    ) : null}
                  </div>
                </div>
                <div className={styles.details}>
                  <div>
                    <h4>Access ID</h4>
                    <span>{userAccessData.id}</span>
                  </div>
                  <div>
                    <h4>User</h4>
                    <span>
                      {userAccessData.user
                        ? userAccessData.user.last_name +
                          ", " +
                          userAccessData.user.first_name
                        : ""}
                    </span>
                  </div>
                  <div>
                    <h4>Client</h4>
                    <span>
                      {userAccessData.client ? userAccessData.client.name : ""}
                    </span>
                  </div>
                  <div>
                    <h4>Access</h4>
                    <span>
                      {userAccessData.role ? userAccessData.role.name : ""}
                    </span>
                  </div>
                  <div>
                    <h4>Created By</h4>
                    <span>{userAccessData.created_by}</span>
                  </div>
                  <div>
                    <h4>Date Created</h4>
                    <span>
                      {moment(userAccessData.created_at)
                        .tz(user.preferences.timeZone)
                        .format("L, LTS z")}
                    </span>
                  </div>
                  <div>
                    <h4>Edited By</h4>
                    <span>{userAccessData.updated_by}</span>
                  </div>
                  <div>
                    <h4>Date Updated</h4>
                    <span>
                      {moment(userAccessData.updated_at)
                        .tz(user.preferences.timeZone)
                        .format("L, LTS z")}
                    </span>
                  </div>
                </div>
              </div>
            </Flex.Item>
          ) : null}
        </Flex>
      </Container>
    </Layout>
  );
};

export default ViewUserAccess;
